import React, { useState, useEffect, useRef } from 'react';
import { getEventObject } from '../../../utils/EventUtils';
import { getValueOrDefault } from '../../../utils/ModalUtils';
import { quantityTypeNames, getQuantityValue, getQuantityName } from '../../../utils/QuantityUtils';

/**
 * props:
 * - id
 * - text
 * - quantity
 * - multiplier
 * - onChange
 */
function QuantityTemplate(props) {

    const [quantityTemplate, setQuantityTemplate] = useState({ quantity: '', multiplier: '' });

    const quantityRef = useRef('');

    function onQuantityChange(event) {
        let value = event.target.value;
        /*
        if (value === 'Max. Wallet')
            value = 'MAX_WALLET';
        else if (value === 'Min. Notional')
            value = 'MIN_NOTIONAL';
        else if (value === 'Last Order Qty.')
            value = 'LAST_ORDER_QTY';
        */
        value = getQuantityValue(value);

        props.onChange(getEventObject(props.id, value));
    }

    useEffect(() => {
        if (props.quantity === null || props.quantity === undefined) return;

        let qty = props.quantity;
        /*
        if (props.quantity === 'MAX_WALLET')
            qty = 'Max. Wallet';
        else if (props.quantity === 'MIN_NOTIONAL')
            qty = 'Min. Notional';
        else if (props.quantity === 'LAST_ORDER_QTY')
            qty = 'Last Order Qty.';
        */
        qty = getQuantityName(qty);

        setQuantityTemplate({ quantity: qty, multiplier: props.multiplier });
    }, [props.quantity, props.multiplier]);

    function clearQuantity(event) {
        quantityTemplate.quantity = '';
        quantityRef.current.value = '';
    }

    const isRiskQty = quantityTemplate.quantity === quantityTypeNames.RISK_QTY;

    return (
        <div className='form-group'>
            <label htmlFor={props.id}>
                {props.text}{' '}
                <span data-bs-toggle="tooltip" data-bs-placement='top'
                    title='Max. Wallet = máximo disponível. Min. Notional = mínimo permitido. Risk Qty. = tamanho por risco fixo % (requer multiplicador de stop < 1). Multiplicador = % para tipos de qtd, fração de risco para Risk Qty.'
                    className='badge bg-warning py-1'>?</span>
            </label>
            <div className='input-group'>
                <input ref={quantityRef} type='text' id={props.id} list='qtyOptions' className='form-control w-50' onChange={onQuantityChange} placeholder='0' value={getValueOrDefault(quantityTemplate.quantity)} />
                {
                    quantityTemplate.quantity !== quantityTypeNames.QUOTE_QTY
                        ? (
                            <span className='input-group-text bg-secondary' onClick={clearQuantity} title='Clique para limpar a quantidade'>X</span>
                        )
                        : <React.Fragment></React.Fragment>
                }
                <input id={props.id + 'Multiplier'} type='number' className='form-control' onChange={props.onChange}
                    placeholder={isRiskQty ? '0.01' : '1'}
                    title={isRiskQty ? 'Fração de risco do capital (ex: 0.01 = 1% por operação)' : 'Multiplicador (1 = 100%)'}
                    value={getValueOrDefault(quantityTemplate.multiplier)} />
                <datalist id='qtyOptions'>
                    <option>{quantityTypeNames.LAST_ORDER_QTY}</option>
                    <option>{quantityTypeNames.MAX_WALLET}</option>
                    <option>{quantityTypeNames.MIN_NOTIONAL}</option>
                    <option>{quantityTypeNames.QUOTE_QTY}</option>
                    <option>{quantityTypeNames.RISK_QTY}</option>
                    <option>{quantityTypeNames.POSITION_QTY}</option>
                </datalist>
            </div>
            {isRiskQty && (
                <small className='text-muted'>Risk Qty: defina o Multiplicador de Stop &lt; 1 (ex: 0.98 = stop de 2%). Multiplicador = % de risco do capital (ex: 0.01 = 1%).</small>
            )}
        </div>
    )
}

export default QuantityTemplate;